import React from 'react';
import { useAuth } from '../contexts/AuthContext';

/**
 * Where "/" leads a user whose permissions include no screen of their own --
 * no dashboard, no accounts, invoices, clients or suppliers. Neutral on
 * purpose: it shows nothing a permission would be needed for.
 */
export default function Welcome() {
  const { user } = useAuth();
  return (
    <div className="p-8 max-w-xl" data-testid="welcome-page">
      <h1 className="text-xl font-bold text-slate-900 mb-2" style={{ fontFamily: 'Chivo, sans-serif' }}>
        Welcome{user?.first_name ? `, ${user.first_name}` : ''}
      </h1>
      <p className="text-sm text-slate-600">
        Use the menu to open the areas of Eyvo FinOps assigned to you. If something you need is
        missing, ask a FinOps administrator.
      </p>
    </div>
  );
}
